<template>
  <div>
    <div class="sc-gzVnrw ipJBfZ">
      <div class="sc-fcdeBU lavEYt topbar-monmi">
        <nav class="navbar navbar-expand-lg navbar-light justify-content-between px-4">
          <div class="icon-hambuger-monmi">
            <a class="navbar-brand" href="#">
              <i class="fas fa-bars"></i>
            </a>
          </div>
          <div class="img-logo-topbar">
            <div class="img-logo">
              <img src="/static/images/logo.png"/>
            </div>
          </div>
          <div class="icon-cart-mobi">
            <button class="btn btn-danger">
              <i class="fas fa-shopping-cart"></i>
            </button>
          </div>
          <div class="collapse navbar-collapse" style="flex-grow:unset" id="navbarSupportedContent">
            <form class="form-inline my-2 my-lg-0">
              <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
            </form>
            <div>
              <button class="btn btn-danger">
                <i class="fas fa-shopping-cart"></i>
              </button>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <div class="submenu-left-monmi">
      <ul class="list-submenu">
        <li>
          <a href=""><i class="fas fa-home pr-3"></i> Trang Chủ</a>
        </li>
        <li>
          <a href=""><i class="fas fa-store pr-3"></i>Cửa hàng</a>
        </li>
        <li>
          <a href=""><i class="fas fa-address-card pr-3"></i>About Us</a>
        </li>
        <li>
          <a href=""><i class="fas fa-user pr-3"></i>Sign In</a>
        </li>
      </ul>
    </div>
    <div class="sc-htoDjs gQKxVj" style="z-index:1"></div>
    <div class="sc-htoDjs gQKxVj" style="z-index:2"></div>
    <div class="sc-htoDjs gQKxVj" style="z-index:3"></div>
    <div class="sc-htoDjs gQKxVj" style="z-index:4"></div>
    <div class="sc-htoDjs gQKxVj" style="z-index:5"></div>
  </div>
</template>

<script>
export default {
  name: "Navbar"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue